import React, { useState } from "react";
import { Loader2 } from "lucide-react";

const STATIC_CARD_IMAGE = "/assets/images/broken.png";

const Card = ({ data, isSelected, onClick }) => {
  const hasProfilePicture = data.image && data.image !== STATIC_CARD_IMAGE;
  const [imgLoaded, setImgLoaded] = useState(false);

  return (
    <div
      className={`hover:bg-[#3FC4E3] cursor-pointer hover:text-white ${
        isSelected ? "bg-[#3FC4E3] text-white" : "bg-white text-black"
      } p-3 rounded-lg border transition-colors duration-200 flex flex-col h-full`}
      onClick={onClick}
    >
      <div className="w-full h-36 rounded-md overflow-hidden bg-gray-100 relative">
        {hasProfilePicture ? (
          <>
            {!imgLoaded && (
              <div className="absolute inset-0 flex items-center justify-center">
                <Loader2 className="w-6 h-6 animate-spin text-themeColor" />
              </div>
            )}
            <img
              src={data.image}
              alt=""
              className="relative w-full h-full object-cover"
              onLoad={() => setImgLoaded(true)}
              onError={(e) => {
                e.target.src = STATIC_CARD_IMAGE;
                setImgLoaded(true);
              }}
            />
          </>
        ) : (
          <img
            src={STATIC_CARD_IMAGE}
            alt=""
            className="w-full h-full object-cover"
          />
        )}
      </div>
      <h1 className="font-popinsSemiBold text-xl mt-4 line-clamp-2">
        {data.organizationName || data.title}
      </h1>
      <p className="font-popinsRegular mt-1 text-sm line-clamp-3">{data.desc}</p>
    </div>
  );
};

export default Card;
